module.exports = __webpack_public_path__ + "fonts/brand-icons.13db00b7.13db00b7.eot";